package com.dwarshb.bms

import kotlinx.browser.document
import kotlinx.browser.localStorage
import kotlinx.browser.window
import org.w3c.dom.HTMLHtmlElement
import org.w3c.dom.asList
import org.w3c.dom.get
import org.w3c.dom.set

// Key to store the language preference under
private const val LANGUAGE_PREF_KEY = "userLocale"

actual fun changeLang(lang: String) {
    try {
        localStorage.set(LANGUAGE_PREF_KEY, lang)
        localStorage.set("composeApp:locale",lang)
        localStorage.set("bms:locale",lang)
        localStorage.set("bms:$LANGUAGE_PREF_KEY",lang)
        localStorage.set("composeApp:$LANGUAGE_PREF_KEY",lang)
        localStorage.asDynamic()
        val htmlElement = document.documentElement as HTMLHtmlElement
        htmlElement.lang = lang
        println("${localStorage.length} \n ${window.navigator.languages[0]} ${window.navigator.language}: $lang")
        println("Web: Persisted language preference: $lang")
    } catch (e: Exception) {
        // localStorage might be disabled or full (though unlikely for a small string)
        println("Web: Error saving language preference to localStorage: ${e.message}")
        // Handle error: log, inform user, potentially use sessionStorage as fallback?
    }
}